import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { NewsHomepageService } from "@app/services/news.homepage.service";
import { WordPressService } from "@app/services/word-press.service";
import { HomePageModule } from "src/app/models/home-page-module.model";
import { HomepageModulesService } from "src/app/services/homepage-modules.service";
import { homepageThematicWpSlug } from "../homepage/homepage-thematic-categories/homepage-thematic-categories.component";

export const homepageResolver: ResolveFn<HomePageModule[]> = async () => {
  const homepageModulesService = inject(HomepageModulesService);
  const newsHomepageService = inject(NewsHomepageService);
  const wp = inject(WordPressService);

  await newsHomepageService.reload();
  const hpmodules = await homepageModulesService.fetchModules();

  const hasThematicCategories = hpmodules.some(
    (m) => m.id === "homepage-thematic-categories",
  );

  if (hasThematicCategories) {
    console.log("hasThematicCategories true, preloading page");
    const page = await wp.getPage(homepageThematicWpSlug);
    if (page) {
      wp.pageCache.set(homepageThematicWpSlug, page);
    }
  }

  return hpmodules;
};
